import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { TruncateHoverDirective } from '../../directives/truncate-hover.directive';
import { IconPipe } from '../../pipes/icon.pipe';
import { TrackByPropertyPipe } from '../../pipes/track-by-property.pipe';
import { RegisterGatewayModalComponent } from '../register-gateway-modal/register-gateway-modal.component';
import { HierarchyPopoverComponent } from './hierarchy-popover/hierarchy-popover.component';
import { SidebarTranslatePipe } from './sidebar-translate.pipe';
import { SidebarComponent } from './sidebar.component';

@NgModule({
  declarations: [SidebarComponent, RegisterGatewayModalComponent],
  imports: [
    CommonModule,
    MatIconModule,
    MatMenuModule,
    MatListModule,
    IconPipe,
    ReactiveFormsModule,
    MatInputModule,
    MatAutocompleteModule,
    RouterModule,
    HierarchyPopoverComponent,
    MatTooltipModule,
    TrackByPropertyPipe,
    MatDialogModule,
    FlexLayoutModule,
    MatSelectModule,
    MatFormFieldModule,
    FormsModule,
    TruncateHoverDirective,
    SidebarTranslatePipe
  ],
  exports: [SidebarComponent, IconPipe]
})
export class SidebarModule {}
